import type * as ents from '@attain-apps/entities'

import type * as endUser from '../../end-user'

/**
 * Represents {@link ents.core.mosaic.Widget.Ref} but features a {@link Ref.id}
 * to make it easier to track distinct {@link ents.core.mosaic.Widget.Ref}
 * within a page
 */
export interface Ref
  extends ents.core.mosaic.Widget.Ref,
    ents.core.common.Identified<Ref.Id> {}
export namespace Ref {
  /**
   * A unique identifier for a {@link ents.core.mosaic.Widget.Ref}
   *
   * Used to identify and track specific {@link ents.core.mosaic.Widget.Ref}
   * instances within a page Content
   */
  export type Id = string
  export namespace Id {
    /**
     * Useful when we are not displaying the {@link ents.core.mosaic.Widget.Ref}
     * in the {@link endUser.currentRendering}
     */
    // eslint-disable-next-line @typescript-eslint/no-shadow
    export const FOR_PREVIEW = 'for_preview'
  }

  /**
   * Useful when we are not displaying the {@link ents.core.mosaic.Widget.Ref}
   * in the {@link endUser.currentRendering}
   */
  export const FOR_PREVIEW: Ref = {
    id: Id.FOR_PREVIEW,
    /**
     * NOTE: Since {@link ents.core.common.FlexibleIdentifier} requires at last
     * one property to be defined, we need to put some custom value
     */
    widget: { alias: 'FOR_PREVIEW' },
  }
}
